Vue.component("file-upload", {
    props: ['title', 'unsupportedText', 'countlimitText', 'sizelimitText', 'list'],
    data: function () {
        return {
            files: [],

            errorMessage: null,
            unsupportedFiles: [],

            errorMessage: null,
            sizeLimitFiles: [],
        };
    },
    mounted: function () {
        var _this = this;

    },
    methods: {
        selectFile: function (event) {
            var _this = this;

            _this.errorMessage = null;
            _this.sizeLimitFiles = [];
            _this.unsupportedFiles = [];

            for (var i = 0; i < event.target.files.length; i++) {
                var file = event.target.files[i];
                if (_this.files.length < 10) {
                    if (_this.isFileTypeValid(file)) {
                        if (_this.isFileSizeValid(file)) {
                            var fileName = file.name.replace(/^.*[\\\/]/, '');
                            var fileSize = (file.size / 1024) > 1024 ? ((file.size / 1024) / 1024).toFixed(2) + 'MB' : (file.size / 1024).toFixed(2) + 'KB';
                            _this.files.push(
                                {
                                    file: file,
                                    name: fileName,
                                    size: fileSize
                                });
                        } else {
                            _this.sizeLimitFiles.push(file.name);
                        }
                    } else {
                        _this.unsupportedFiles.push(file.name);
                    }
                } else {
                    _this.errorMessage = _this.countlimitText;
                }
            }
            _this.list = _this.files;
            _this.$emit('update:list', _this.list);
        },
        deleteFile: function (index, e) {
            e.preventDefault();
            this.files.splice(index, 1);
            this.errorMessage = null;
        },
        isFileTypeValid: function (file) {
            const validTypes = ['jpeg', 'jpg', 'png', 'pdf', 'mp4', 'doc', 'docx'];
            return $.inArray(file.name.split('.').pop(), validTypes) > 0;
        },
        isFileSizeValid: function (file) {
            return file.size <= 5120 * 1024;//5MB
        }
    },
    template: '<div>\
               <div class="custom-upload">\
                   <input type="file" id="up1" name="up1" class="custom-upload__inputfile" @change="selectFile($event)" multiple="false">\
                   <label for="up1" class="button button--primary button--medium">{{title}}</label>\
               </div>\
               <div class="custom-upload__filelist">\
                    <p v-show="errorMessage" style="color:#ff0000">{{errorMessage}}</p>\
                    <p v-show="unsupportedFiles.length > 0" style="color:#ff0000">{{unsupportedText}}</p>\
                     <ul v-show="unsupportedFiles.length > 0" style="color:#ff0000">\
                         <li v-for="f in unsupportedFiles">{{f}}</li>\
                     </ul>\
                    <p v-show="sizeLimitFiles.length > 0" style="color:#ff0000">{{sizelimitText}}</p>\
                     <ul v-show="sizeLimitFiles.length > 0" style="color:#ff0000">\
                         <li v-for="f in sizeLimitFiles">{{f}}</li>\
                     </ul>\
                   <div class="custom-upload__item" v-for="(file, index) in files">\
                       <span class="custom-upload__item-name">{{file.name}}</span>\
                       <span class="custom-upload__item-size">{{file.size}}</span>\
                       <a href="" class="custom-upload__item-delete" v-on:click="deleteFile(index, $event)">\
                           <svg>\
                               <use xlink:href="~/m/i/icons.svg#symbol-close"></use>\
                           </svg>\
                       </a>\
                   </div>\
               </div>\
           </div>'
});